import { messages } from './RoleStep.messages';

/**
 * Adopted roles needed because our Radio accept strings only
 */
export enum AdoptedRole {
    Director = 'director',
    Owner = 'owner',
    DirectorWithOwnership = 'director/owner',
}

export const adoptedRoleToMessage = {
    [AdoptedRole.Director]: messages.director,
    [AdoptedRole.Owner]: messages.owner,
    [AdoptedRole.DirectorWithOwnership]: messages.directorWithOwnership,
};

export const roles = [
    { id: AdoptedRole.Director, name: adoptedRoleToMessage[AdoptedRole.Director] },
    { id: AdoptedRole.Owner, name: adoptedRoleToMessage[AdoptedRole.Owner] },
    { id: AdoptedRole.DirectorWithOwnership, name: adoptedRoleToMessage[AdoptedRole.DirectorWithOwnership] },
];
